import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../contexts/notification.context';
import {
  createAuthUserWithEmailAndPassword,
  createUserDocumentFromAuth
} from '../../utils/firebase/firebase.utils';
import Button from '../button/button.component';
import FormInput from '../form-input/form-input.component';

const defaultFormFields = {
  displayName: '',
  email: '',
  password: '',
  confirmPassword: ''
};

const SignUpForm = () => {
  const navigate = useNavigate();
  const { notify } = useNotification();

  const [formFields, setFormFields] = useState(defaultFormFields);
  const { displayName, email, password, confirmPassword } = formFields;

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      notify('Les deux mots de passe ne correspondent pas', 'error');
      return;
    }

    try {
      const { user } = await createAuthUserWithEmailAndPassword(
        email,
        password
      );

      await createUserDocumentFromAuth(user, { displayName });
      resetFormFields();
      navigate('/');
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {
        notify('Un compte existe déjà avec cette adresse email', 'error');
      } else {
        notify('La création du compte a échoué, réessayez', 'error');
        console.log('user creation encountered an error', error);
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormFields({ ...formFields, [name]: value });
  };

  return (
    <div className="auth-card">
      <h2 className="auth-card-title">Pas encore de compte ?</h2>
      <p className="auth-card-lead">
        Créez un compte en enregistrant votre email et un mot de passe.
      </p>
      <form onSubmit={handleSubmit}>
        <FormInput
          label="Nom complet"
          type="text"
          required
          onChange={handleChange}
          name="displayName"
          value={displayName}
        />

        <FormInput
          label="Email"
          type="email"
          required
          onChange={handleChange}
          name="email"
          value={email}
        />

        <FormInput
          label="Mot de passe"
          type="password"
          required
          onChange={handleChange}
          name="password"
          value={password}
        />

        <FormInput
          label="Confirmez le mot de passe"
          type="password"
          required
          onChange={handleChange}
          name="confirmPassword"
          value={confirmPassword}
        />
        <Button type="submit">Créer le compte</Button>
      </form>
    </div>
  );
};

export default SignUpForm;
